import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import BeachChairWithSun from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/BeachChairWithSun';
import DollarSignWithFourArrowsPointingInward from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/DollarSignWithFourArrowsPointingInward';
import HandWithThreePlusSigns from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/HandWithThreePlusSigns';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'non-qualified-retirement-plan-reward-key-contributors',
    icon: HandWithThreePlusSigns,
    title: 'Reward key contributors',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Employers can choose which employees can participate in non&#45;qualified retirement plans so they can be a great way to attract and retain executive level employees.
      </Typography>
    ),
  },
  {
    id: 'non-qualified-retirement-plan-save-more-for-retirement',
    icon: BeachChairWithSun,
    title: 'Save more for retirement',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Since traditional retirement plans like a 401(k) have contribution limits, employers can help key employees save more of their income now to help meet their income needs in retirement.
      </Typography>
    ),
  },
  {
    id: 'non-qualified-retirement-plan-reduce-taxable-income',
    icon: DollarSignWithFourArrowsPointingInward,
    title: 'Reduce taxable income',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Because compensation is deferred, you can draw on the funds when you&#39;re in a lower tax bracket, typically once you retire.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='non-qualified-retirement-plan'
      headingSubTextAlignment='left'
      headingText={
        <>
          Benefits of non&#45;qualified <WidowBlock>retirement plans</WidowBlock>
        </>
      }
      headingSubText={
        <Typography
          component='span'
          nextElement='typography'>
          See the top ways that Elective Deferred Compensation Plans, SERP Plans, and Phantom Stock Plans can help business owners and key employees.
        </Typography>
      }
      cardDataArray={ITEMS}
    />
  );
};
